import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import SocialAuth from "./pages/social-auth";
import { useDispatch } from "react-redux";
import React, { useEffect } from "react";
import { loadUser } from "./redux/actions/login.action";
import SearchComponent from "./pages/Home/Search";
import ChannelComponent from "./pages/Home/channel";
import HomeRoute from "./pages/Routes/homeRoute";
import Login from "./pages/Home/login";
import ProtectedRoute from "./pages/Routes/protectedRoute";
import DebugPage from "./pages/Home/Debug";
import MoveToRootPage from "./pages/Home/MoveToRoot";
import VisualChangelog from "./pages/Home/VisualChangelog";
import DeepFind from "./pages/Home/DeepFind";
import LandscapeWarning from "./components/LandscapeWarning";
import { AppLayout, ChannelLayout } from "./layouts";
import { ThemeProvider } from "./components/theme-provider";
import DownloadPage from "./pages/Download";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  return (
    <>
      <LandscapeWarning />

        <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <Routes>
          {" "}
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            {/* Standard pages with shared AppBar + FooterBar layout */}
            <Route element={<AppLayout />}>
              <Route exact path="/" element={<HomeRoute />} />
              <Route path="/dashboard" element={<Home />} />
              <Route path="/canvas" element={<Home />} />
              <Route path="/folder/:folderId" element={<Home />} />
              <Route path="/search" element={<SearchComponent />} />
              <Route path="/debug" element={<DebugPage />} />
              <Route path="/move-to-root" element={<MoveToRootPage />} />
              <Route path="/visual-changelog" element={<VisualChangelog />} />
              <Route path="/deep-find" element={<DeepFind />} />
            </Route>

            {/* Channel pages with their own ChannelAppBar + FooterBar */}
            <Route element={<ChannelLayout />}>
              <Route path="/channels" element={<ChannelComponent />} />
              <Route
                path="/channels/:channelId"
                element={<ChannelComponent />}
              />
            </Route>
          </Route>
          {/* Public Routes (no layout) */}
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/google" element={<SocialAuth />} />
          <Route exact path="/download" element={<DownloadPage />} />
      </Routes>
      </ThemeProvider>
    </>
  );
};

export default App;
